// Staff copy for one branch's own page in Administration → Branches
// (admin/BranchPage.tsx).
// Native review pending (az, ru): the Azerbaijani and Russian here are a first
// draft. Change a phrase in all three languages at once, never in one.
import type { Phrase } from '../staffText'

export const branchPage = {
  'bp.back': { en: 'All branches', az: 'Bütün filiallar', ru: 'Все отделения' },
  'bp.notFound': { en: 'No branch with the code {code}.', az: '{code} kodlu filial yoxdur.', ru: 'Нет отделения с кодом {code}.' },
  'bp.edit': { en: 'Edit', az: 'Dəyiş', ru: 'Изменить' },
  'bp.settings': { en: 'Settings', az: 'Ayarlar', ru: 'Настройки' },
  'bp.hours': { en: 'Hours', az: '', ru: '' },
  'bp.reset': { en: 'Reset now', az: '', ru: '' },
  'bp.resetTitle': { en: 'Reset {name}?', az: '', ru: '' },
  'bp.resetSub': { en: 'Closes open tickets, signs out desks and restarts numbers.', az: '', ru: '' },
  'bp.resetYes': { en: 'Reset', az: '', ru: '' },
  'bp.resetDone': { en: 'Day reset: {n} closed', az: '', ru: '' },
  // Machines and their designs (admin/equipment/BranchEquipment.tsx, MachinePage.tsx).
  'bpm.machines': { en: 'Machines', az: '', ru: '' },
  'bpm.machinesLine': { en: 'What each machine shows.', az: '', ru: '' },
  'bpm.fromProfile': { en: 'From profile: {name}', az: '', ru: '' },
  'bpm.useProfile': { en: 'Use profile', az: '', ru: '' },
  'bpm.editDesign': { en: 'Edit design', az: '', ru: '' },
  'bpm.machine': { en: 'Machine', az: '', ru: '' },
  'bpm.details': { en: 'Branch details', az: '', ru: '' },
  'bpm.screen': { en: 'Screen', az: '', ru: '' },
  'bpm.address': { en: 'Address', az: '', ru: '' },
  'bpm.app': { en: 'Screen app', az: '', ru: '' },
} satisfies Record<string, Phrase>
